import { h, createContext } from 'preact';
import { useState } from 'preact/hooks';
export var AlertContext = createContext({});
var AlertProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), options = _b[0], setOptions = _b[1];
    return h(AlertContext.Provider, { value: { options: options, setOptions: setOptions } }, children);
};
export default AlertProvider;
